export const initialBiobankReportColumns = [
  // {
  //   label: "Quality labels:",
  //   column: {
  //     quality: [{ quality_standard: ["name"] }],
  //   },
  // },
  {
    label: "Dataset types:",
    column: {
      collections: [
        "id",
        { type: ["label"] },
        // {
        //   quality: [{ quality_standard: ["name"] }],
        // },
        // { sub_collections: ["id"] },
        // { parent_collection: ["id"] },
      ],
    },
  },
  // { label: "Biobank capabilities:", column: { capabilities: ["label"] } },
  /** properties that are required but should not be rendered as attributes */
  {
    column: [
      "id",
      "title",
      "collections.id",
      "collections.title",
      // "collections.sub_collections.withdrawn",
    ],
  },
];

export default initialBiobankReportColumns;
